import BudgetIndex from "../Components/BudgetIndex";

function Index() {
    return (
       <BudgetIndex />
    );
}

export default Index;